import { useEffect } from "react";
import OneTrust from "shared/util/oneTrust";

function useXAxisPixel({ isLoggedIn, gender, age }) {
	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (!isLoggedIn || !gender || !age) {
			return;
		}

		OneTrust.loadScript(
			`https://gmtdmp.mookie1.com/tagr/v1/activity?acid=2&inst=NA&tagid=54516519&src.rand=${Math.round(Math.random() * 10000)}&trb.clientID=133&trb.activityID=6927&src.Gender=${gender}&src.Age=${age}`,
			OneTrust.CATEGORY.ADVERTISING,
		);
	}, [age, gender, isLoggedIn]);
}

export default useXAxisPixel;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useXAxisPixel.js